import { Pipe, PipeTransform } from '@angular/core';
import { MonitoredTrain } from '@/app/features/monitoring/models/monitored-train';
import { TreeNode } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ProjectConfiguration } from '@/app/features/project/models/project-configuration';
import { TrainTypeConfiguration } from '../models/monitored-train';

@Pipe({
  name: 'trainTreeStructure',
  pure: false
})
export class TrainTreeStructurePipe implements PipeTransform {

  constructor (
    private translate: TranslateService
  ) {

  }

  transform(train: MonitoredTrain, trainTypeConfiguration: TrainTypeConfiguration ): TreeNode[] {
    const deviceConfigurations = trainTypeConfiguration?.dynamicConsistConfig?.deviceConfigurations;
    if (deviceConfigurations && train && train.structure && train.structure.deviceGroups) {
      train.structure.deviceGroups = train.structure.deviceGroups.map((deviceGroup) => {
        deviceGroup.devices.map((device) => {
          device.surfIPAddress = device.ipAddr;
          const deviceConfig = deviceConfigurations && device.type ? deviceConfigurations.find(conf => conf.type.toLowerCase() === device.type.toLowerCase()) : null;
          if(deviceConfig && deviceConfig.remapIPto) {
              if (Number.isInteger(parseInt(deviceConfig.remapIPto))) {
                device.surfIPAddress = device.ipAddr + ":" + deviceConfig.remapIPto;
              } else { // the following is implemented for hh project
                const ipRemappingPort = trainTypeConfiguration?.dynamicConsistConfig?.ipRemappingPort || 10000;
                const targetDevice = train.structure.allDevices.find(target => target.type === deviceConfig.remapIPto);
                if (targetDevice) {
                  device.surfIPAddress = targetDevice.ipAddr + ':' + (ipRemappingPort + device.deviceId).toString();
                }
              }
          }
          device.enableSSL = deviceConfig ? deviceConfig.enableSSL : false;
          return device
      })
      return deviceGroup;
    })
    }

    return train
      ? <TreeNode[]>[
          {
            key: train.structure.hashCode,
            label: train.name,
            type: 'train',
            expanded: true,
            data: {
              hashCode: train.structure.hashCode,
              style: train.alarmAckStyle
            },
            children: train.structure.deviceGroups.map(group => {
              return {
                key: group.hashCode,
                label: group.name.replace('Coach', this.translate.instant('I18N_MONITORING.COACH')),
                paintedLabel: (group.paintedCoachId && group.paintedCoachId !== 'unknown') ?  group.paintedCoachId :  group.name.replace('Coach', this.translate.instant('I18N_MONITORING.COACH')),
                type: 'deviceGroup',
                expanded: true,
                data: {
                  hashCode: group.hashCode,
                  style: group.alarmAckStyle,
                },
                children: group.devices.map(device => {
                  return {
                    key: device.hashCode,
                    label: device.splittedName,
                    type: 'device',
                    data: {
                      style: device.alarmAckStyle,
                      hashCode: device.hashCode,
                      ipAddr: device.ipAddr,
                      serial: device.serial,
                      device: {...device}
                    }
                  }
                })
              }
            })
          }
        ]
      : [];
  }

}
